import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppRoutes} from './app.route';
import {MainComponent} from './layouts';
import {LayoutsModule} from './layouts/layouts.module';
import {SharedModule} from './shared/shared.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {NgxWebstorageModule} from 'ngx-webstorage';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { environment as env } from '../environments/environment';

@NgModule({
  declarations: [
    MainComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' }),
    NgxWebstorageModule.forRoot({prefix: 'SFL-AURA', separator: '-'}),
    FormsModule,
    HttpClientModule,
    AuthModule.forRoot(
    {
      ...env.auth0,
      // httpInterceptor: { // these calls will have the bearer token injected (aka most API calls)!
      //   allowedList: [
      //     `${env.api.serverUrl}/api/messages/admin`, 
      //     `${env.api.serverUrl}/api/messages/protected`, 
      //     `${env.localUrl}/customer/dashboard`,
      //     `${env.API_URL}customers`,
      //     `${env.API_URL}users`,
      //     `${env.API_URL}users/*`,
      //     `${env.API_URL}devices/customer`,
      //     `${env.API_URL}devices/customer/*`,
      //     `${env.API_URL}device/firmwares`,
      //   ],
      // },
    }
  ),
    SharedModule,
    LayoutsModule,
    MatProgressBarModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    }
  ],
  bootstrap: [
    MainComponent
  ],

})

export class AppModule {
}
